import { RedeemCurrentStateI } from '@interfaces/redux/base-state'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
export const redeemCurrentStateSlice = createSlice({
    name: 'redeemCurrentState',
    initialState: {
        active: false,
        data: undefined,
        section:undefined,
        tab: undefined
    } as RedeemCurrentStateI,
    reducers: {
        /**
         * @param current state
         * @param action payload with new data to update state
         */
        setRedeemCurrentState: (state, action: PayloadAction<RedeemCurrentStateI>) => {
            state.active = action.payload.active
            state.data = action.payload.data
            state.section = action.payload.section
            state.tab = action.payload.tab
        },
        setRedeemCurrentStateData: (state, action: PayloadAction<{data: unknown}>) => {
            state.data = action.payload.data
        },
        setRedeemCurrentStateActive: (state, action: PayloadAction<{data: boolean}>) => {
            state.active = action.payload.data
        },
        cleanRedeemCurrentState: (state) => {
            state.active = false
            state.data = undefined
            state.section = undefined
            state.tab = undefined
        },
    },
})

export const { setRedeemCurrentState, setRedeemCurrentStateData, cleanRedeemCurrentState } = redeemCurrentStateSlice.actions
export default redeemCurrentStateSlice.reducer
